import React from 'react';
import { PasswordRecoveryChangeTemplate } from 'themes/modules/membership/pages';
import { setCurrentView } from 'core/utils';
import { PasswordRecoveryChangeViewStore } from 'modules/membership/stores';

@setCurrentView(rootStore => new PasswordRecoveryChangeViewStore(rootStore))
class PasswordRecoveryChange extends React.Component {
	render() {
		return <PasswordRecoveryChangeTemplate {...this.props} />;
	}
}

export default PasswordRecoveryChange;
